import { IDocumentEditable } from "..";
import { EditPhaseKinds } from "../../../../domain/document";
import { DateItem, IItem, TextBoxItem, instanceOfIHisInformationApplicable } from "../../../../domain/document/items";
import { DateInputMethodKinds } from "../../../../domain/document/inputMethodKinds/DateInputMethodKinds";
import { FuzzyDate } from "../../../../domain/system";
import { HisItemParameter } from "../../../../domain/his/behavior";
import { HisInformationRollbackValueMaster } from "../../../../domain/his/master";
import { User } from "../../../../domain/user";
import { TextBoxInputMethodKinds } from "../../../../domain/document/inputMethodKinds";
import { IConfiguration } from "../../../../domain/configuration";
import store from "../../../../store";


export class MischievousHisInformationApplicator {
  constructor(private _document: IDocumentEditable, private _user: User, private _isOrderableUser: boolean) {
  }

  public apply(): void {
    if (this.shouldUpdateCreateDateOnEditStart) {
      this.updateCreateDate();
    }
    if (this.shouldFillDoctorAutomaticallyOnEditStart && !!this._user && this._isOrderableUser) {
      this.fillDoctor();
    }
  }

  private updateCreateDate(): void {
    const today = new Date();
    for (let itemSetId = 0; itemSetId < this._document.itemSets.length; itemSetId++) {
      const itemSet = this._document.itemSets[itemSetId];
      for (const item of itemSet.items) {
        if (!this.isCreateDate(item)) { continue; }
        if (item instanceof DateItem && item.value instanceof FuzzyDate && this.isCreateDateUpdatableCondition(item)) {
          const cloned = item.clone() as DateItem;
          cloned.value.value = new Date(today);
          // V1では強制的に毎回更新する設定の時はカレンダー入力に変更したオブジェクトも入力不可に戻している模様
          // カレンダー入力のまま値が勝手に変わるよりは分かりやすいため、同様の挙動にしている
          // isCreateDate()でもisHisInfoの判定しているが念のため確認している
          if (cloned.isHisInfo && cloned.inputMethodKind !== DateInputMethodKinds.None) {
            cloned.inputMethodKind = DateInputMethodKinds.None;
          }
          this._document.updateItem(cloned, {
            itemSetId,
          });
        }
      }
    }
  }

  private isCreateDateUpdatableCondition(item: DateItem): boolean {
    const configuration = store.getters.configuration as IConfiguration;
    if (configuration.behavior.document.editor.mischievousObjects.createDate.shouldUpdateAndRollbackExceptFreeInputSelectedObject) {
      return item.inputMethodKind !== DateInputMethodKinds.FreeInput;
    } else {
      return item.inputMethodKind === DateInputMethodKinds.None;
    }
  }

  private fillDoctor(): void {
    for (let itemSetId = 0; itemSetId < this._document.itemSets.length; itemSetId++) {
      const itemSet = this._document.itemSets[itemSetId];
      for (const item of itemSet.items) {
        if (!this.isDoctor(item)) { continue; }
        if (item instanceof TextBoxItem && item.isEmpty && item.inputMethodKind !== TextBoxInputMethodKinds.FreeInput) {
          const cloned = item.clone() as TextBoxItem;
          cloned.value = this._user.name;
          this._document.updateItem(cloned, {
            itemSetId,
          });
        }
      }
    }
  }

  private get shouldFillDoctorAutomaticallyOnEditStart(): boolean {
    return this._document.source.attributes.behavior.shouldFillDoctorAutomaticallyOnEditStart;
  }

  private get shouldUpdateCreateDateOnEditStart(): boolean {
    return this._document.source.attributes.behavior.shouldUpdateCreateDateOnEditStart;
  }

  private get shouldRollbackCreateDateOnTemporarySave(): boolean {
    return this._document.source.attributes.behavior.shouldRollbackCreateDateOnTemporarySave;
  }

  private isCreateDate(item: IItem): boolean {
    return instanceOfIHisInformationApplicable(item)
      && item.isHisInfo
      && item.hisItemParameter.key === "CREATE_DATE";
  }

  private isDoctor(item: IItem): boolean {
    return instanceOfIHisInformationApplicable(item)
      && item.isHisInfo
      && item.hisItemParameter.key === "DOCTOR";
  }

  public shouldRollbackValue(hisItemParameter: HisItemParameter, progress: EditPhaseKinds): boolean {
    return HisInformationRollbackValueMaster.shouldRollbackValue(hisItemParameter, progress, this.shouldRollbackCreateDateOnTemporarySave);
  }

  /**
   * カレンダー入力状態の作成日の毎回更新しない設定にしたとき、ワークフロー文書の作成日がカレンダー入力に切り替わってしまうと更新されないので対策している
   */
  public shouldSkipInputMethodKindUpdate(item: IItem): boolean {
    return this.shouldUpdateCreateDateOnEditStart && (item instanceof DateItem) && this.isCreateDate(item) && this.isCreateDateUpdatableCondition(item);
  }
}
